import { createSlice } from "@reduxjs/toolkit";
import { verifyNin } from "./api";

const initialState = {
  response: {},
  loading: false,
  error: null,
};

const verifyNinSlice = createSlice({
  name: "verifyNin",
  initialState,

  reducers: {
    clearVerifyNinResponse: () => initialState,
  },

  extraReducers: (builder) => {
    builder.addCase(verifyNin.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(verifyNin.fulfilled, (state, action) => {
      state.response = action.payload;
      state.loading = false;
    });

    builder.addCase(verifyNin.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { clearVerifyNinResponse } = verifyNinSlice.actions;

export default verifyNinSlice.reducer;
